<div class="map-container">
  <div class="map-wrapper" [style.height.px]="height">
    <div #mapContainer class="map-root"></div>
  </div>

  <div class="map-overlay" *ngIf="loading">
    <i class="pi pi-spin pi-spinner"></i>
  </div>

  <div class="map-placeholder" *ngIf="!loading && pops.length === 0">
    No PoP has geographic coordinates to display on the map.
  </div>
</div>
